import { useState, useEffect } from 'react';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import data from '../../../data/target-incentivos.json';

// JSON-LD Structured Data for Target Incentivos
const jsonLdData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Target Incentivos",
  "alternateName": "Gestão Completa de Campanhas de Incentivo",
  "url": "https://www.targetsoftware.com.br/incentivos",
  "provider": {
    "@type": "Organization",
    "name": "Target Software",
    "url": "https://www.targetsoftware.com.br",
    "logo": "https://www.targetsoftware.com.br/assets/img/logo.png"
  },
  "description": "O Target Incentivos é a solução líder em gestão completa de campanhas de incentivo, remuneração variável e apuração automatizada, oferecendo flexibilidade total para qualquer regra de negócio, múltiplas integrações e dashboards personalizados.",
  "serviceType": "Gestão de Campanhas de Incentivo e Remuneração Variável",
  "areaServed": {
    "@type": "Country",
    "name": "Brasil"
  },
  "audience": {
    "@type": "BusinessAudience",
    "businessSize": "SMB/Enterprise",
    "industry": "Telecom, Varejo, Serviços Financeiros, Indústria, Benefícios, Tecnologia"
  },
  "offers": {
    "@type": "Offer",
    "price": "Sob consulta",
    "priceCurrency": "BRL",
    "availability": "https://schema.org/InStock"
  },
  "brand": {
    "@type": "Brand",
    "name": "Target Software"
  },
  "hasPart": [
    {
      "@type": "Service",
      "name": "Campanhas Flexíveis",
      "description": "Configuração para qualquer regra de comissão, incentivo ou premiação."
    },
    {
      "@type": "Service",
      "name": "Múltiplas Integrações",
      "description": "Integração com diversas origens de dados para máxima flexibilidade operacional."
    },
    {
      "@type": "Service",
      "name": "Atualização Automática",
      "description": "Notificações e atualizações automáticas de desempenho em tempo real."
    },
    {
      "@type": "Service",
      "name": "Dashboards Avançados",
      "description": "Dashboards completos, rankings, simuladores e aplicativos móveis integrados."
    },
    {
      "@type": "Service",
      "name": "Prêmios Flexíveis",
      "description": "Ofereça prêmios, resgates, pagamentos em folha e diversas modalidades."
    },
    {
      "@type": "Service",
      "name": "Suporte Dedicado",
      "description": "Equipe de suporte operacional especializada para operações de RV e incentivos."
    },
    {
      "@type": "Service",
      "name": "Aceleração com IA",
      "description": "Insights por IA para análise de números, contestações e performance."
    }
  ],
  "keywords": [
    "campanhas de incentivo",
    "incentivos comerciais",
    "remuneração variável",
    "apuração de RV",
    "comissionamento",
    "gestão comercial",
    "plataforma de incentivos",
    "premiações",
    "campanhas de vendas",
    "automação de incentivos",
    "software de remuneração variável",
    "gestão de equipes comerciais"
  ],
  "image": "https://www.targetsoftware.com.br/assets/img/target-incentivos-banner.png"
};

const TargetIncentivosPage = () => {
  const [showVideoModal, setShowVideoModal] = useState(false);

  const { diferenciais, cases } = data;

  const handleContactClick = () => {
    window.location.href = '/contato';
  };

  // Add JSON-LD structured data to head
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLdData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Banner */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#7d2128] via-[#9d2832] to-[#bd3142]">
        <div className="absolute inset-0">
          <img 
            src="/images/produtos/target-incentivos.jpg"
            alt="Target Incentivos"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#7d2128]/80 to-[#7d2128]/60"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-center text-white">
            <div className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium mb-6">
              <i className="ri-trophy-line mr-2"></i>
              Solução Líder em Incentivos
            </div>
            <h1 className="text-5xl lg:text-7xl font-bold leading-tight mb-6">
              Target Incentivos
            </h1>
            <p className="text-xl lg:text-2xl text-gray-200 max-w-4xl mx-auto mb-8 leading-relaxed">
              Gestão completa de campanhas de incentivo e remuneração variável <br />
              <strong className="text-white"> sem limitação por usuários</strong> e com 
              <strong className="text-white"> flexibilidade total</strong> <br /> para qualquer regra de negócio
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <div className="flex items-center text-lg">
                <i className="ri-check-line text-green-400 mr-2"></i>
                <span>Configurável para qualquer regra</span>
              </div>
              <div className="flex items-center text-lg">
                <i className="ri-check-line text-green-400 mr-2"></i>
                <span>Integração com múltiplas origens</span>
              </div>
              <div className="flex items-center text-lg">
                <i className="ri-check-line text-green-400 mr-2"></i>
                <span>Suporte operacional dedicado</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Saiba Mais - Vídeo */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Conheça o <span className="text-[#7d2128]">Target Incentivos</span>
          </h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Descubra como nossa plataforma revoluciona a gestão de incentivos e remuneração variável, 
            proporcionando flexibilidade total e resultados excepcionais para sua equipe comercial.
          </p>
          <button
            onClick={() => setShowVideoModal(true)}
            className="inline-flex items-center px-8 py-4 bg-[#7d2128] text-white font-semibold rounded-xl hover:bg-[#6d1f24] transition-all duration-300 hover:scale-105 hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line text-2xl mr-3"></i>
            Assistir Vídeo de Apresentação
          </button>
        </div>
      </section>

      {/* Diferenciais */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Diferenciais de Mercado
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Conheça os principais diferenciais que fazem do Target Incentivos <br />a escolha ideal para sua empresa
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {diferenciais.map((diferencial, index) => (
              <div key={index} className="group">
                <div className="bg-gray-50 rounded-2xl p-6 h-full hover:bg-[#7d2128] transition-all duration-300 hover:shadow-xl hover:-translate-y-1 cursor-pointer">
                  <div className="w-12 h-12 bg-[#7d2128] rounded-xl flex items-center justify-center mb-4 group-hover:bg-white transition-colors duration-300">
                    <i className={`${diferencial.icon} text-2xl text-white group-hover:text-[#7d2128]`}></i>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3 group-hover:text-white transition-colors duration-300">
                    {diferencial.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed group-hover:text-gray-200 transition-colors duration-300">
                    {diferencial.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cases de Sucesso */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Cases de Sucesso
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Grandes empresas já confiam no Target Incentivos para transformar seus resultados
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {cases.map((caso, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="flex items-center mb-6">
                  <img 
                    src={caso.logo} 
                    alt={caso.cliente}
                    className="h-12 w-auto object-contain"
                  />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  {caso.cliente}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {caso.descricao}
                </p>
                <ul className="mt-4 space-y-2">
                  {caso.indicadores && caso.indicadores.map((indicador, idx) => (
                    <li key={idx} className="flex items-center text-gray-700 text-sm font-medium">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {indicador}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-20 bg-[#7d2128]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Pronto para evoluir sua estratégia comercial?
          </h2>
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            Entre em contato conosco e descubra como o Target Incentivos pode transformar <br />
            a gestão de campanhas e remuneração variável da sua empresa.
          </p>
          <button
            onClick={handleContactClick}
            className="inline-flex items-center px-8 py-4 bg-white text-[#7d2128] font-semibold rounded-xl hover:bg-gray-100 transition-all duration-300 hover:scale-105 hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line text-xl mr-3"></i>
            Falar com Especialista
          </button>
        </div>
      </section>

      {/* Video Modal */}
      {showVideoModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl p-6 max-w-2xl w-full">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold text-gray-900">Vídeo de Apresentação</h3>
              <button
                onClick={() => setShowVideoModal(false)}
                className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>
            <div className="bg-gray-100 rounded-xl p-8 text-center">
              <i className="ri-video-line text-4xl text-gray-400 mb-4"></i>
              <p className="text-gray-600">
                O vídeo de apresentação será disponibilizado em breve. 
                Entre em contato para mais informações.
              </p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default TargetIncentivosPage;